// Getting
import {CrmSystemTypes} from "./actionsTypes";

export const getCrmSystem = (id: number) => ({
    type: CrmSystemTypes.GET_CRM_SYSTEM,
    id
})
export const getCrmSystemSuccess = (data: any) => ({
    type: CrmSystemTypes.GET_CRM_SYSTEM_SUCCESS,
    payload: data,
})

export const getCrmSystemFail = (error: any) => ({
    type: CrmSystemTypes.FAIL_CRM_SYSTEMS,
    payload: error,
})

export const getCrmSystems = (next_page: string, filter: object) => ({
    type: CrmSystemTypes.GET_CRM_SYSTEMS,
    next_page,
    filter
})
export const getCrmSystemsSuccess = (data: any) => ({
    type: CrmSystemTypes.GET_CRM_SYSTEMS_SUCCESS,
    payload: data,
})

export const getCrmSystemsFail = (error: any) => ({
    type: CrmSystemTypes.FAIL_CRM_SYSTEMS,
    payload: error,
})

// Adding
export const addCrmSystem = (data: any) => ({
    type: CrmSystemTypes.ADD_CRM_SYSTEM,
    data
})

export const addCrmSystemSuccess = (data: any) => ({
    type: CrmSystemTypes.ADD_CRM_SYSTEM_SUCCESS,
    payload: data
})

export const addCrmSystemFail = (error: any) => ({
    type: CrmSystemTypes.FAIL_CRM_SYSTEMS,
    payload: error,
})

// Updating
export const updateCrmSystem = (data: any, id: number) => ({
    type: CrmSystemTypes.UPDATE_CRM_SYSTEM,
    id, data
})

export const updateCrmSystemSuccess = (data: any) => ({
    type: CrmSystemTypes.UPDATE_CRM_SYSTEM_SUCCESS,
    payload: data
})

export const updateCrmSystemFail = (error: any) => ({
    type: CrmSystemTypes.FAIL_CRM_SYSTEMS,
    payload: error,
})

// Removing
export const deleteCrmSystem = (id: number) => ({
    type: CrmSystemTypes.DELETE_CRM_SYSTEM,
    id
})

export const deleteCrmSystemSuccess = (id: number) => ({
    type: CrmSystemTypes.DELETE_CRM_SYSTEM_SUCCESS,
    payload: id
})

export const deleteCrmSystemFail = (error: any) => ({
    type: CrmSystemTypes.FAIL_CRM_SYSTEMS,
    payload: error,
})

// Other
export const clearCrmSystem = () => ({
    type: CrmSystemTypes.CLEAR_CRM_SYSTEM,
})

export const clearCrmSystems = () => ({
    type: CrmSystemTypes.CLEAR_CRM_SYSTEMS,
})

export const modalCrmSystem = (status: boolean) => ({
    type: CrmSystemTypes.MODAL_CRM_SYSTEM,
    status
})